import React from "react";
import "../../Components/Menu/Menu.css";

export default function Record() {
  return (
    <div>
      <h4 className="sub-title">Disse dataene registreres og lagres </h4>
      <p className="content">
        <ul>
          <li>Fornavn og etternavn</li>
          <li>Fødselsnummer</li>
          <li>Telefonnummer,adresse og e-post </li>
          <li>
            Registreringsnummer, modell og annen informasjon om eide eller
            leasede biler registrert på deg
          </li>
          <li> Lokasjon, hvis du samtykker</li>
        </ul>
        <p>
          Vi registrerer og lagrer fødselsnummeret ditt i appen, slik at vi kan
          hente inn oppdatert informasjon om hvilke kjøretøy du eier eller
          leaser. Informasjonen hentes fra Autosys (Statens vegvesen), som
          krever sikker innlogging for å hente ut informasjonen på dine vegne.
          Se mer informasjon om Autosys under avsnittet «Innhenting og deling av
          data med tredjeparter».
        </p>{" "}
        <p>
          Appen inneholder en tilbakemeldingsfunksjon som du kan bruke når du
          vil gi GMG tilbakemeldinger om appen. I tilbakemeldingsfunksjonen kan
          du oppgi kundenummeret ditt og e-postadressen din, slik at GMG kan
          komme i dialog med deg. Tilbakemeldingene blir sendt til en
          e-postkasse i GMG.
        </p>
      </p>
    </div>
  );
}
